export const PRODUCT_TYPE = Object.freeze({
  MAIN_PRODUCT: 'main_product',
  BUNDLE: 'bundle',
  ADDITIONAL_PRODUCT: 'additional_product',
  WARRANTY: 'warranty',
  FREE: 'free',
  FREE_MEMBER: 'free_member',
  FREE_HANDRAISER: 'free_handraiser',
  UNSET_FREE: 'unset_free',
  DELIVERY: 'delivery',
  PROMOTION: 'promotion',

  CART_BUNDLE: 'bundle',
})

export default PRODUCT_TYPE
